// extracted by mini-css-extract-plugin
export default {"container":"OrgBanner_container__UsMfj","content":"OrgBanner_content__3muF7","org_container":"OrgBanner_org_container__1tgpu","name":"OrgBanner_name__2oMaq"};